<span class="input-component">
    <label>{{ label | translate }}</label>
    <div class="content">
        <input  #input
                type="text"
                class="form-select"
                [ngClass]="{ 'disabled': isDisabled || control.disabled, 'is-invalid': control.invalid && control.touched }"
                [formControl]="control"
                [placeholder]="placeholder | translate"
                [matAutocomplete]="auto"
                (input)="filter()"
                (focus)="filter()">

        <mat-autocomplete requireSelection #auto="matAutocomplete">
            @if (!isDisabled && !control.disabled) {
                @for (option of filteredOptions; track option.value) {
                    <mat-option [value]="option.name">{{option.name | translate}}</mat-option>
                }
            }
        </mat-autocomplete>
    </div>
</span>
